import React, { useContext, useState, useEffect, useRef } from 'react'
import CustomTable from '../../../../product/components/molecules/CustomTable'
import CustomSearch from '../../../../product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '../../../../product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import CustomDialog from '../../../../product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '../../../../product/components/organisms/FullScreenPopup'
import SecondaryButton from '../../../../product/components/atoms/SecondaryButton'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import SettingContext from '../../../../product/context/setting/settingContext'
import {
    validationFunction,
    initialFunction,
    editValue,
} from '../../../components/species/dynamic/common/FieldFunction'
import { useTranslation } from 'react-i18next'

const TableSettings = (props) => {
    const settingcontext = useContext(SettingContext)
    const variableName = props.variableName
    const arrayValue = props.arrayValue
    const tableHeading = props.tableHeading
    const ignoreField = props.ignoreField
    const tableJoins = props.tableJoins

    const { getGlobalVariable, alldata_all_dropdown } =
        useContext(CustomCommonContext)
    const { t } = useTranslation()
    const customContext = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(false)
    const [validationArray, setValidationArray] = useState({})
    const [valueLoaded, setValueLoaded] = useState(false)
    const [initialValues, setInitialValues] = useState({})
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [mapDataValue, setMapDataValue] = useState([])
    const [reload, setReload] = useState(false)
    const [editValues, setEditValues] = useState([])

    const variableValues = customContext[variableName]
    const primaryTable = props.primaryTable
    const customTable = props.customTable
    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id, secondaryID) => {
        if (popup) {
            setManage({ popup, status, id, secondaryID })
        } else {
            setManage({ popup, status: 'new', id: 0, secondaryID: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: primaryTable,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                          ? 1
                          : 0
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })

    const formik = useFormik({
        initialValues: { ...initialValues, table: primaryTable },
        validateOnBlur: false,
        validationSchema: Yup.object(validationArray),
        enableReinitialize: true,
        onSubmit: (values) => {
            if (props.TemplateId) {
                values.template_id = props.TemplateId
            }
            searchTableAction(values)
        },
    })

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: props.initialLimit || 1000,
            orderby: props.orderBy || '',
            primaryTable: primaryTable,
            customTable: customTable || '',
            filters: props.filters,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            if (tableJoins) {
                values.tableJoins = tableJoins
            }
            searchTableFetch(values, primaryTable)
        },
    })

    const [tableActions, setTableActions] = useState([])
    let incomingAction = props.tableActionString

    useEffect(() => {
        let tempTableActions = [
            {
                label: 'Move to Active',
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
            },
            {
                label: 'Move to Deactive',
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactive',
            },
            {
                label: 'Delete Permanently',
                icon: <span className="material-icons">cancel</span>,
                onclick: onSelectMultiProducts,
                type: 'delete',
            },
        ]
        tempTableActions = tempTableActions?.filter((d) =>
            incomingAction?.length ? incomingAction?.includes(d.type) : false
        )

        setTableActions(tempTableActions)
    }, [incomingAction])

    useEffect(() => {
        if (primaryTable) {
            setTableBody([])
            setIsLoading(true)
            formikFetch.values.page = 1
            searchTableFetch(formikFetch.values, primaryTable)
        }
    }, [primaryTable])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === primaryTable) {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setEditValues(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )

                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                toggleFullScreenPopup(false)
                searchTableFetch(formikFetch.values, primaryTable)
                setTableBody([])
                getGlobalVariable()
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            toggleFullScreenPopup(true, 'edit', id)
        }
    }

    const resetForm = () => {
        setInitialValues(initialEmptyValues)
        setReload(!reload)
    }

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            changeChangeStatus()
        }
    }

    // tableActions.push(
    //     {
    //         label: 'Move to Active',
    //         icon: <span className="material-icons">check_circle</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'active',
    //     },
    //     {
    //         label: 'Move to Deactive',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'deactive',
    //     },
    //     {
    //         label: 'Delete Permanently',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'delete',
    //     },
    // )
    const tableValues = props.tableValues

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: props.tooltipTitle ? props.tooltipTitle : 'Edit',
            },
        ]
        return actionPush
    }

    useEffect(() => {
        if (props.editButton) {
            let index = tableValues.findIndex((e) => e.field == 'action')

            if (index < 0) {
                tableValues.push({
                    field: 'action',
                    type: 'button',
                    clickID: 'id',
                    secondaryClickID: props.secondaryClickID
                        ? props.secondaryClickID
                        : '',
                    sort: false,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Action',
                    isMultiple: getMultipleAction(),
                })
            }
        }
    }, [props.editButton])

    const searchInfo = props.searchInfo || null

    // [
    //     {
    //         label: `${tableHeading} name`,
    //         placeholder: `Enter ${tableHeading} name`,
    //         class: 'col-md-4 col-sm-6 col-12',
    //         type: 'text',
    //         name: 'searchterm',
    //         formik: formikFetch,
    //     },
    // ]

    useEffect(() => {
        setValidationArray({})
        if (arrayValue.length) {
            let mapValueArray = arrayValue
            let handle = validationFunction(
                mapValueArray,
                props.customValidation,
                t
            )
            setValidationArray(handle)
        }
    }, [arrayValue, props.customValidation])

    useEffect(() => {
        setValueLoaded(false)
        setInitialValues({})
        setInitialEmptyValues({})
        setMapDataValue([])
        let custom = props.customInitial

        if (arrayValue.length) {
            let mapValueArray = arrayValue
            let { tempMapData, show } = initialFunction(
                mapValueArray,
                alldata_all_dropdown
            )

            setInitialValues({ ...custom, ...show })
            setInitialEmptyValues({ ...custom, ...show })

            setMapDataValue(tempMapData)

            setTimeout(() => {
                if (tempMapData.length) {
                    setValueLoaded(true)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [arrayValue])

    const handleEdit = (edit_value) => {
        if (edit_value && edit_value.length) {
            let objectPush = editValue(arrayValue, edit_value[0])
            setInitialValues(objectPush)
            setReload(!reload)
        }
    }

    useEffect(() => {
        if (manage.status === 'edit') {
            formik.setFieldValue('id', manage.id)
            if (variableValues) {
                const template = variableValues.filter(
                    (cat) => cat.id === manage.id
                )
                handleEdit(template)
            } else {
                const template = editValues.filter(
                    (cat) => cat.id === manage.id
                )
                handleEdit(template)
            }
        } else {
            resetForm()
        }
    }, [manage])

    return (
        <>
            <div className="dashboard staticPages">
                {searchInfo ? (
                    <CustomSearch
                        searchInfo={searchInfo}
                        formik={formikFetch}
                    />
                ) : null}

                {arrayValue.length ? (
                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <Button
                            id="setting_add"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() =>
                                toggleFullScreenPopup(true, 'new', 0)
                            }
                        >
                            <span className="material-icons">note_add</span>Add
                            New {tableHeading}
                        </Button>
                    </div>
                ) : null}

                <CustomTable
                    formik={formikFetch.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={search_fetch_data}
                    changeTableFunction={searchTableFetch}
                    columnStorageVariable={'table_settings_custom_table_manage'}
                />
            </div>
            <FullScreenPopup
                modaltitle={
                    manage.status === 'new'
                        ? `Add ${tableHeading}`
                        : `Edit ${tableHeading}`
                }
                open={manage.popup}
                handleClose={() => toggleFullScreenPopup(false, 'new', 0)}
            >
                <div className="dashboard addNewListing mt-4">
                    <div className="fspBody">
                        <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        >
                            <div className="row">
                                {mapData({ formik, data: mapDataValue })}
                            </div>
                            <div className="actionButton d-flex justify-content-center align-items-center">
                                {/* <SecondaryButton
                                    label="Reset"
                                    type="reset"
                                    onClick={() => resetForm()}
                                /> */}
                                <PrimaryButton
                                    id="tableSetting_submit"
                                    type="submit"
                                    label="Submit"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </FullScreenPopup>

            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'delete'
                        ? 'Are you sure you want to delete'
                        : 'Are you sure you want to change the status'}
                </h5>
                <div className="actionWrapper">
                    <Button
                        id="setting_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="tableSetting_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}
export default TableSettings
